import { SvgBase } from "../svg.base";

export const Copy: React.FC<{ size?: number }> = ({ size }) => (
  <SvgBase
    width={"" + (size || 24)}
    height={"" + (size || 24)}
    viewBox="0 0 24 24"
  >
     <g fill="none" fillRule="evenodd">
        <g fill="currentcolor" fillRule="nonzero">
            <g>
                <g>
                    <path d="M19.75 4.75c1.105 0 2 .895 2 2v14c0 1.105-.895 2-2 2h-11c-1.105 0-2-.895-2-2v-14c0-1.105.895-2 2-2h11zm0 1.5h-11c-.245 0-.45.177-.492.41l-.008.09v14c0 .245.177.45.41.492l.09.008h11c.245 0 .45-.177.492-.41l.008-.09v-14c0-.245-.177-.45-.41-.492l-.09-.008zm-3-5.25v1.5h-11c-.647 0-1.18.492-1.244 1.122L4.5 3.75v13H3v-13c0-1.463 1.142-2.658 2.582-2.745L5.75 1h11z" transform="translate(-456 -592) translate(424 590) translate(32 2)"/>
                </g>
            </g>
        </g>
    </g>
  </SvgBase>
);